import Sidebar from '@/components/Sidebar';
import { Suspense, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '@yaradigitallabs/ahua-react';
import { NonIsolationScreens, SidebarRoutes } from '@/app/routes';

import { getClassNames } from '@/utils/helpers';

const Layout = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const disableSidebar = !NonIsolationScreens.includes(location.pathname);

  return (
    <section
      className={getClassNames(
        'flex flex-row',
        disableSidebar ? `mt-[152px]!` : 'mt-14!'
      )}
    >
      {!disableSidebar && (
        <Sidebar
          routes={SidebarRoutes}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          selected={location.pathname}
        />
      )}
      <div
        className={getClassNames(
          'relative bg-[#F3F6F9] overflow-x-hidden overflow-y-auto',
          !disableSidebar
            ? `transition-margin ${
                !collapsed
                  ? `duration-500 ease-out  min-w-[calc(100vw-220px)]`
                  : `duration-300 ease-in min-w-[calc(100vw-80px)]`
              } h-[calc(100vh-60px)] max-h-[calc(100vh-60px)]`
            : `w-full h-[calc(100vh-152px)]`
        )}
      >
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </div>
    </section>
  );
};

export default Layout;
